import { render } from "./AssistedEnrollmentStep2.vue?vue&type=template&id=cdad81ae&scoped=true"
import script from "./AssistedEnrollmentStep2.vue?vue&type=script&lang=js"
export * from "./AssistedEnrollmentStep2.vue?vue&type=script&lang=js"

import "./AssistedEnrollmentStep2.vue?vue&type=style&index=0&id=cdad81ae&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdad81ae"]])

export default __exports__